// extracted by mini-css-extract-plugin
module.exports = {"labeled_total":"list-multas_labeled_total__1S8jr","table_wrapper":"list-multas_table_wrapper__uL2E1","empty_table_messagebox":"list-multas_empty_table_messagebox__1yKs5"};